import './Home.css';

const ExternalLink = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className="external-link"
  >
    {children}
  </a>
);

function Home() {
  const partners = [
    { name: 'Bruno Faviero', url: 'https://www.linkedin.com/in/faviero' },
    { name: 'Max Kolysh', url: 'https://www.linkedin.com/in/maxkolysh/' }
  ];

  const portfolioCompanies = [
    { name: 'Monad', url: 'https://www.monadlabs.xyz/' },
    { name: 'Alpen', url: 'https://www.alpenlabs.io/' },
    { name: 'Movement', url: 'https://movementlabs.xyz/' },
    { name: '3RM', url: 'https://www.3rm.co/' },
    { name: 'Helius', url: 'https://www.helius.dev/' },
    { name: 'OpenGradient', url: 'https://opengradient.ai/' },
    { name: 'Credal', url: 'https://www.credal.ai/' },
    { name: 'CoFrame', url: 'https://www.coframe.com/' },
    { name: 'Vellum', url: 'https://www.vellum.ai/' },
    { name: 'ZBiotics', url: 'https://zbiotics.com/' },
    { name: 'Nitra', url: 'https://www.nitra.com/' },
    { name: 'Slingshot AI', url: 'https://www.slingshot.xyz/' },
    { name: 'Polimorphic', url: 'https://www.polimorphic.com/' },
    { name: 'Pangea Bio', url: 'https://www.pangeabio.com/' },
    { name: 'Anagenex', url: 'https://www.anagenex.com/' },
    { name: 'Ansa Bio', url: 'https://ansabio.com/' }
  ];

  return (
    <div className="home">
      <div className="home-content">
        <p className="tagline">
          Alloy Fund invests in exceptional founders.
        </p>

        <div className="section">
          <strong>Partners: </strong>
          {partners.map((partner, index) => (
            <span key={partner.name}>
              <ExternalLink href={partner.url}>
                {partner.name}
              </ExternalLink>
              {index < partners.length - 1 && ', '}
            </span>
          ))}
        </div>

        <div className="section">
          <strong>Select portfolio companies: </strong>
          {portfolioCompanies.map((company, index) => (
            <span key={company.name}>
              <ExternalLink href={company.url}>
                {company.name}
              </ExternalLink>
              {index < portfolioCompanies.length - 1 && ', '}
            </span>
          ))}
        </div>

        <div className="section">
          <strong>Reach out:</strong>{' '}
          <a href="mailto:hi@alloyfund.com" className="email-link">
            hi@alloyfund.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
